import React from "react";
import _ from "lodash";

const fetchJson = (url, options = {}) => {
  return fetch(url, options).then((response) => response.json());
};

const sendEmail = (data, formId = process.env.REACT_APP_FORVIZ_FORM_ID) => {
  const url = `${process.env.REACT_APP_FORVIZ_FORM_HOST}/forms/${formId}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  return fetchJson(url, options).then((res) => {
    console.log("sendEmail", res);
    if (_.get(res, "data") === "success") {
      return true;
    }
    return false;
  });
};

const assetsPath = (key) => {
  const url = process.env.REACT_APP_CLOUDFRONT;
  if (key === "preview-trip") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_PREVIEW_TRIP}`;
  }
  if (key === "phuket-laguna-village-residences") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_VILLAGE_RESIDENCES}`;
  }
  if (key === "phuket-laguna-village-residences-dev") {
    return "/location/phuket/phuket-laguna-village-residences/assets";
  }
  if (key === "phuket-laguna-park-2") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_PARK2}`;
  }
  if (key === "phuket-laguna-park-2-dev") {
    return `${url}/location/phuket/laguna-park-2-dev/assets`;
  }
  if (key === "laguna-beachside") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_LAGUNA_BEACHSIDE}`;
  }
  if (key === "laguna-beachside-dev") {
    return "/location/phuket/laguna-beachside/assets";
  }
  if (key === "laguna-seaside-residences") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_LAGUNA_SEASIDE_RESIDENCES}`;
  }
  if (key === "laguna-seaside-residences-dev") {
    return "/location/phuket/laguna-seaside-residences/assets";
  }
  if (key === "phuket-skypark") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_PHUKET_SKYPARK}`;
  }
  if (key === "phuket-skypark-dev") {
    return "/location/phuket/skypark/assets";
  }
  if (key === "phuket-dusit-deluxe-pool-villa") {
    return `${url}/${process.env.REACT_APP_CLOUDFRONT_PHUKET_DUSIT_DELUXE_POOL_VILLA}`;
  }
  return `${url}/${process.env.REACT_APP_CLOUDFRONT_ASSET}`;
};

const getParameterByName = (name, url = "") => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const objectToParameter = (obj) => {
  let str = "";
  for (const key in obj) {
    if (str !== "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
};

const parameterToObject = () => {
  const search = window.location.search.substring(1);
  if (!search) return {};
  return JSON.parse(
    '{"' +
      decodeURI(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
};

const parseQueryString = (query = window.location.search.substring(1)) => {
  const vars = query.split("&");
  const qs = {};
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split("=");
    const key = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof qs[key] === "undefined") {
      qs[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof qs[key] === "string") {
      const arr = [qs[key], decodeURIComponent(value)];
      qs[key] = arr;
      // If third or later entry with this name
    } else {
      qs[key].push(decodeURIComponent(value));
    }
  }
  return qs;
};

const getOrdinalSuffixWithElement = (txt) => {
  const splitTxt = _.split(txt, " ");
  const number = _.toNumber(splitTxt[0]);
  console.log("getOrdinalSuffix", splitTxt);
  if (!/[0-9]/.test(number)) return txt;
  const j = number % 10;
  const k = number % 100;
  let ordinal = "th";
  if (j === 1 && k !== 11) {
    ordinal = "st";
  }
  if (j === 2 && k !== 12) {
    ordinal = "nd";
  }
  if (j === 3 && k !== 13) {
    ordinal = "rd";
  }
  // return `${num} ${ordinal} ${str}`;
  // console.log("splitTxt", splitTxt);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {number}
      <sup
        style={{ fontSize: "10px", textTransform: "none" }}
      >{`${ordinal}`}</sup>
      &nbsp;
      {/* {splitTxt[2]} */}
      {_.map(splitTxt, (i, k) => {
        if (k >= 2) {
          return <span>{`${i}`}&nbsp;</span>;
        }
        return <span />;
      })}
    </div>
  );
};

// const withOrdinalSuffix = (num) => {
//   const number = _.toNumber(num);
//   if (!/[0-9]/.test(number)) return num;
//   const j = number % 10;
//   const k = number % 100;
//   if (j === 1 && k !== 11) {
//     return `${number}st`;
//   }
//   if (j === 2 && k !== 12) {
//     return `${number}nd`;
//   }
//   if (j === 3 && k !== 13) {
//     return `${number}rd`;
//   }
//   return `${number}th`;
// };

export {
  fetchJson,
  sendEmail,
  assetsPath,
  getParameterByName,
  objectToParameter,
  parameterToObject,
  parseQueryString,
  getOrdinalSuffixWithElement,
};



// WEBPACK FOOTER //
// ./src/utils/index.js